let backend_url;
if (process.env.VUE_APP_ENVIRONMENT === "dev") {
  backend_url = process.env.VUE_APP_BACKEND_URL_DEV;
} else {
  backend_url = process.env.VUE_APP_BACKEND_URL_PROD;
}

module.exports = {
  backend_url,
};
